// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {find, get, includes, isRegExp} from 'lodash';

// Components
import AccordionButton from './accordion-button';
import AccordionPanel from './accordion-panel';
import Button from './button';

// Configs
import errorConfig from '../../../config/error-config';

// Styles
import './error.scss';

function Error({
    absolutePositioned,
    children,
    className,
    clearButtonChildren='clear error',
    error,
    fixedPositioned,
    onClear,
    onReset,
    resetButtonChildren='reset',
}) {
    const getAccordionProps = () => ({
        disableDefaultToggle: true,
        detailsRenderer: renderErrorDetails,
    });

    const getClass = () => classnames(
            {
                error: true,
                error_absolute: absolutePositioned,
                error_fixed: fixedPositioned,
            },
            className
        );

    const getErrorMessage = () => get(
            find(errorConfig, (item) => isRegExp(item.pattern) ? item.pattern.test(error) : includes(error, item.pattern),
            ),
            'message'
        ) || error;

    const renderClearButton = () => (onClear ? (
            <Button className="error--button" onClick={onClear}>
                {clearButtonChildren}
            </Button>
        ) : null);

    const renderDetailAccordion = (errorMessage) => (error && error !== errorMessage ? (
            <AccordionPanel {...getAccordionProps()}>
                <AccordionButton className="error--accordion-button">Details</AccordionButton>
            </AccordionPanel>
        ) : null);

    const renderError = () => {
        const errorMessage = getErrorMessage();

        return (
            <div className={getClass()}>
                <div className="error--content">{errorMessage}</div>
                {renderClearButton()}
                {renderResetButton()}
                {renderDetailAccordion(errorMessage)}
                {children}
            </div>
        );
    };

    const renderErrorDetails = () => <div className="error--details">{error}</div>;

    const renderResetButton = () => (onReset ? (
            <Button className="error--button" onClick={onReset}>
                {resetButtonChildren}
            </Button>
        ) : null);

    return children || (error && error !== '') ? renderError() : null;
}

Error.propTypes = {
    absolutePositioned: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
    clearButtonChildren: PropTypes.node,
    error: PropTypes.string,
    fixedPositioned: PropTypes.bool,
    onClear: PropTypes.func,
    onReset: PropTypes.func,
    resetButtonChildren: PropTypes.node,
};

// Error.defaultProps = {
//     clearButtonChildren: 'clear error',
//     resetButtonChildren: 'reset',
// };

export default Error;
